import Konva from 'konva/konva'

const size = { width: 50, height: 20 }
const padding = 4
const margin = 4
const cornerRadius = 9
const font = { family: 'Roboto', size: 12, color: 'rgba(0,0,0,0.87)' }
const color = '#f0f0f0'
const border = { color: 'Black', width: 1 }

export default class EventClusterBadge extends Konva.Group {
  constructor ({ x, y, count, eventId }) {
    super()
    Object.assign(this, { x, y, count, eventId })

    this.render()
  }

  render () {
    const { x, y } = this
    const label = new Konva.Label({
      x: x - size.width - margin, y: y - size.height - margin
    })

    label.add(new Konva.Tag({
      fill: color,
      stroke: border.color,
      strokeWidth: border.width,
      cornerRadius
    }))

    label.add(new Konva.Text({
      text: this._formatText(),
      fontFamily: font.family,
      fontSize: font.size,
      padding,
      fill: font.color,
      width: size.width,
      height: size.height,
      align: 'center'
    }))

    this.add(label)
  }

  _formatText () {
    const { count, eventId } = this
    return (eventId + 1) + ' / ' + count
  }
}
